import { put, takeLatest, select } from 'redux-saga/effects';
import {
  GET_DISCOUNT_RECOMMEND_LIST,
  SET_DISCOUNT_RECOMMEND_LIST,
  GET_DISCOUNT_RANK_LIST,
  SET_DISCOUNT_RANK_LIST,
  GET_DISCOUNT_RANK_MENU,
  SET_DISCOUNT_RANK_MENU,
} from '../constants/discount';
import { createAxios } from '../utils/utils';
import { RECOMMEND_LIST, RANK_LIST_90, RANK_MENU_90 } from '../config';
import Toast from '../components/Toast/Toast';

function* handleGetDiscountRecommentList({ payload }) {
  yield put({
    type: SET_DISCOUNT_RECOMMEND_LIST,
    payload: {
      loading: true,
    },
  });
  const params = payload.pageCursor ? { pageCursor: payload.pageCursor || null } : {};
  const axios = yield createAxios();
  const res = yield axios.post(RECOMMEND_LIST, params);

  try {
    const { data, message, status } = res.data;
    if (status === 0) {
      if (payload && payload?.refresh) {
        yield put({
          type: SET_DISCOUNT_RECOMMEND_LIST,
          payload: {
            refresh: true,
          },
        });
        yield put({
          type: SET_DISCOUNT_RECOMMEND_LIST,
          payload: {
            ...data,
            loading: false,
          },
        });
      } else if (payload && payload?.pageCursor) {
        yield put({
          type: SET_DISCOUNT_RECOMMEND_LIST,
          payload: {
            ...data,
            loading: false,
          },
        });
      }
    } else {
      Toast.error({ content: message });
      throw new Error('11');
    }
  } catch (error) {}
}

export function* watchGetDiscountRecommendList() {
  yield takeLatest(GET_DISCOUNT_RECOMMEND_LIST, handleGetDiscountRecommentList);
}

function* fetchDiscountRankList({ payload }) {
  if (payload?.refresh) {
    yield put({
      type: SET_DISCOUNT_RANK_LIST,
      data: {
        ...payload,
        pageCursor: '',
        loading: true,
      },
    });
  }

  const axios = yield createAxios('isNeedUser');
  const res = yield axios.post(RANK_LIST_90, {
    ...payload,
  });
  try {
    if (res?.data?.status === 0) {
      yield put({
        type: SET_DISCOUNT_RANK_LIST,
        data: {
          ...payload,
          loading: false,
          data: res?.data?.data,
        },
      });
    }
  } catch (e) {
    yield put({
      type: SET_DISCOUNT_RANK_LIST,
      data: {
        ...payload,
        pageCursor: '',
        loading: true,
      },
    });
  }
}

export function* watchFetchDiscountRankList() {
  yield takeLatest(GET_DISCOUNT_RANK_LIST, fetchDiscountRankList);
}

function* fetchDiscountRankMenu({ payload }) {
  const axios = yield createAxios('isNeedUser');
  const res = yield axios.get(RANK_MENU_90, {
    ...payload,
  });
  if (res?.data?.status === 0) {
    yield put({
      type: SET_DISCOUNT_RANK_MENU,
      data: res.data.data,
    });
  }
}

export function* watchFetchDiscountRankMenu() {
  yield takeLatest(GET_DISCOUNT_RANK_MENU, fetchDiscountRankMenu);
}
